import _regeneratorRuntime from "/app/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var axios = require("axios");

var JSZip = require("jszip");

var Msal = require('msal');

export var Property = /*#__PURE__*/function () {
  function Property(propertyXML) {
    _classCallCheck(this, Property);

    this._unit = "no unit";
    this._name = "";
    this._dimension = 1;
    var attributes = propertyXML.attributes;

    for (var i = 0; i < attributes.length; i++) {
      var attr = attributes[i];

      if (attr.localName === "name") {
        this._name = attr.nodeValue;
      } else if (attr.localName === "unit") {
        this._unit = attr.nodeValue;
      } else if (attr.localName === "dimension") {
        this._dimension = Number(attr.nodeValue);
      }
    }
  }

  _createClass(Property, [{
    key: "getName",
    value: function getName() {
      return this._name;
    }
  }, {
    key: "setName",
    value: function setName(name) {
      this._name = name;
    }
  }, {
    key: "getUnit",
    value: function getUnit() {
      return this._unit;
    }
  }, {
    key: "setUnit",
    value: function setUnit(unit) {
      this._unit = unit;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return this._dimension;
    }
  }, {
    key: "setDimension",
    value: function setDimension(dim) {
      this._dimension = dim;
    }
  }]);

  return Property;
}();
export var Continuum = /*#__PURE__*/function () {
  function Continuum(continuumXML) {
    _classCallCheck(this, Continuum);

    this._id = "";
    this._tag = "";
    this._category = "";
    this._x = null;
    this._z = null;
    this._d = [];
    this._property = [];
    this._sourceType = "";
    this._data = {};
    this._map2d = [];
    this._md = [];
    this._key = 0;
    var attributes = continuumXML.attributes;

    for (var i = 0; i < attributes.length; i++) {
      var attr = continuumXML.attributes[i];

      if (attr.localName === "id") {
        this._id = attr.nodeValue;
      }

      if (attr.localName === "sourceType") {
        this._id = attr.nodeValue;
      }
    }

    var children = continuumXML.children;

    for (var _i = 0; _i < children.length; _i++) {
      var child = children[_i];

      if (child.localName === "tag") {
        this._tag = child.childNodes.length > 0 ? child.childNodes[0].nodeValue : "";
      } else if (child.localName === "type") {
        this._type = child.childNodes[0].nodeValue;
      } else if (child.localName === "category") {
        this._category = child.childNodes.length > 0 ? child.childNodes[0].nodeValue : "";
      } else if (child.localName === "x" || child.localName === "z") {
        var d = {};
        var _attributes = child.attributes;

        for (var j = 0; j < _attributes.length; j++) {
          var _attr = _attributes[j];
          d[_attr.nodeName] = Number(_attr.nodeValue);
        }

        if (child.localName === "x") {
          this._x = d;
        } else {
          this._z = d;
        }
      } else if (child.localName === "property") {
        this._property.push(new Property(child));
      }
    }
  }

  _createClass(Continuum, [{
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "setId",
    value: function setId(id) {
      this._id = id;
    }
  }, {
    key: "getTag",
    value: function getTag() {
      return this._tag;
    }
  }, {
    key: "setTag",
    value: function setTag(tag) {
      this._tag = tag;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this._type;
    }
  }, {
    key: "setType",
    value: function setType(type) {
      this._type = type;
    }
  }, {
    key: "getCategory",
    value: function getCategory() {
      return this._category;
    }
  }, {
    key: "setCategory",
    value: function setCategory(cat) {
      this._category = cat;
    }
  }, {
    key: "getx",
    value: function getx() {
      return this._x;
    }
  }, {
    key: "setx",
    value: function setx(x) {
      this._x = x;
    }
  }, {
    key: "getz",
    value: function getz() {
      return this._z;
    }
  }, {
    key: "setz",
    value: function setz(z) {
      this._z = z;
    }
  }, {
    key: "getproperty",
    value: function getproperty() {
      return this._property;
    }
  }, {
    key: "addData",
    value: function addData(property, data) {
      this._data[property] = data;
    }
  }, {
    key: "getData",
    value: function getData(property) {
      return this._data[property];
    }
  }, {
    key: "hasData",
    value: function hasData() {
      return Object.keys(this._data).length > 0;
    }
  }, {
    key: "hasData",
    value: function hasData(property) {
      return property in this._data;
    }
  }, {
    key: "setMap2d",
    value: function setMap2d(map2d) {
      this._map2d = map2d;
    }
  }, {
    key: "getMap2d",
    value: function getMap2d() {
      return this._map2d;
    }
  }, {
    key: "setMD",
    value: function setMD(md) {
      this._md = md;
    }
  }, {
    key: "getMD",
    value: function getMD() {
      return this._md;
    }
  }, {
    key: "forceUpdate",
    value: function forceUpdate() {
      this._key += 1;
    }
  }]);

  return Continuum;
}();
export var Model = /*#__PURE__*/function () {
  function Model(continuaXML) {
    _classCallCheck(this, Model);

    this._tag = continuaXML.getElementsByTagName("model")[0].getAttribute("tag");
    this._continuum = [];
    var continuum = continuaXML.getElementsByTagName("continuum");

    for (var i = 0; i < continuum.length; i++) {
      this._continuum.push(new Continuum(continuum[i]));
    }
  }

  _createClass(Model, [{
    key: "getTag",
    value: function getTag() {
      return this._tag;
    }
  }, {
    key: "setTag",
    value: function setTag(tag) {
      this._tag = tag;
    }
  }, {
    key: "getcontinuum",
    value: function getcontinuum() {
      return this._continuum;
    }
  }]);

  return Model;
}();
export var plotlyDefaultColorscales = ["Greys", "YlGnBu", "Greens", "YlOrRd", "Bluered", "RdBu", "Reds", "Blues", "Picnic", "Rainbow", "Portland", "Jet", "Hot", "Blackbody", "Earth", "Electric", "Viridis", "Cividis"];
export var CesHttpClient = /*#__PURE__*/function () {
  function CesHttpClient(serverURL) {
    var authToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var useAuthentication = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, CesHttpClient);

    this._serverURL = serverURL;
    this._progressBar = null;
    this.authToken = authToken;
    this.useAuthentication = useAuthentication;
    this.cesDefaultColormaps = null;
  }

  _createClass(CesHttpClient, [{
    key: "setProgressBar",
    value: function setProgressBar(progressBar) {
      this._progressBar = progressBar;
    }
  }, {
    key: "getServerURL",
    value: function getServerURL() {
      return this._serverURL;
    }
  }, {
    key: "getAuthToken",
    value: function getAuthToken() {
      return this.authToken;
    }
  }, {
    key: "getCesDefaultColormaps",
    value: function getCesDefaultColormaps() {
      return this.cesDefaultColormaps;
    }
  }, {
    key: "testServerConnectionWithoutAuth",
    value: function () {
      var _testServerConnectionWithoutAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.get(this._serverURL + "/continuums").then(function (response) {
                  // handle success
                  return {
                    status: true,
                    authToken: null
                  };
                }).catch(function (error) {
                  // handle error
                  var msg = "Can not connect to server: " + _this._serverURL + ". " + error;
                  console.log(msg);
                  alert(msg);
                  return {
                    status: false,
                    authToken: null
                  };
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function testServerConnectionWithoutAuth() {
        return _testServerConnectionWithoutAuth.apply(this, arguments);
      }

      return testServerConnectionWithoutAuth;
    }()
  }, {
    key: "acquireAuthToken",
    value: function () {
      var _acquireAuthToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var config, authCallback, myMSALObj, accessTokenRequest;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                authCallback = function _authCallback(error, response) {
                  //handle redirect response
                  console.log("authCallback", error, response);
                };

                config = {
                  /*auth: {
                      clientId: "fcc5cf3a-1e98-4d8e-a26c-b8fcb7e0e473", 
                      authority: "https://login.microsoftonline.com/bluware.com"
                  }*/
                  auth: {
                    clientId: "e8791767-ff8b-4d17-ad50-678f3c8d2a02",
                    authority: "https://login.microsoftonline.com/equinor.com"
                  }
                };
                // create UserAgentApplication instance
                myMSALObj = new Msal.UserAgentApplication(config); // (optional when using redirect methods) register redirect call back for Success or Error

                myMSALObj.handleRedirectCallback(authCallback);
                accessTokenRequest = {
                  // scopes: ["api://fcc5cf3a-1e98-4d8e-a26c-b8fcb7e0e473/cesapiserver.any.all"],
                  scopes: ["api://e8791767-ff8b-4d17-ad50-678f3c8d2a02/cesapiserver.any.all"]
                };
                return _context2.abrupt("return", myMSALObj.loginPopup(accessTokenRequest).then(function (response) {
                  return myMSALObj.acquireTokenSilent(accessTokenRequest).then(function (accessTokenResponse) {
                    // Acquire token silent success
                    console.log("Acquire token silent success");
                    var token = accessTokenResponse.idToken.rawIdToken;
                    _this2.authToken = token;
                    return token;
                  }).catch(function (error) {
                    //Acquire token silent failure, and send an interactive request
                    console.log("Acquire token silent failure", error);
                    console.log(error.errorMessage.indexOf("login is required"));

                    if (error.errorMessage.indexOf("login is required") !== -1) {
                      myMSALObj.acquireTokenPopup(accessTokenRequest).then(function (accessTokenResponse) {
                        console.log("Acquire token interactive success");
                        var token = accessTokenResponse.idToken.rawIdToken;
                        return token;
                      }).catch(function (error2) {
                        console.log("Acquire token interactive failure: ", error2.errorMessage); // Acquire token interactive failure

                        console.log(error2);
                        return null;
                      });
                    }

                    console.log(error);
                    return null;
                  });
                }).catch(function (err) {
                  // handle error
                  var msg = "Login interactive failure" + err.errorMessage;
                  console.log(msg);
                  alert(msg);
                  return null;
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function acquireAuthToken() {
        return _acquireAuthToken.apply(this, arguments);
      }

      return acquireAuthToken;
    }()
  }, {
    key: "testServerConnectionWithAuth",
    value: function () {
      var _testServerConnectionWithAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var token;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.acquireAuthToken();

              case 2:
                token = _context3.sent;
                // console.log('testServerConnectionWithAuth()', token);
                this.authToken = token;
                return _context3.abrupt("return", axios.get(this._serverURL + "/continuums", {
                  headers: {
                    "Authorization": "Bearer ".concat(token)
                  }
                }).then(function (response) {
                  console.log("Test server connection success"); // console.log(response);

                  return {
                    status: true,
                    authToken: token
                  };
                }).catch(function (error) {
                  // handle error
                  var msg = "Can not connect to server: " + _this3._serverURL + ". " + error;
                  console.log(msg);
                  alert(msg);
                  return {
                    status: false,
                    authToken: null
                  };
                }));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function testServerConnectionWithAuth() {
        return _testServerConnectionWithAuth.apply(this, arguments);
      }

      return testServerConnectionWithAuth;
    }()
  }, {
    key: "testServerConnection",
    value: function () {
      var _testServerConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.useAuthentication) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 3;
                return this.testServerConnectionWithAuth();

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 6:
                _context4.next = 8;
                return this.testServerConnectionWithoutAuth();

              case 8:
                return _context4.abrupt("return", _context4.sent);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function testServerConnection() {
        return _testServerConnection.apply(this, arguments);
      }

      return testServerConnection;
    }()
  }, {
    key: "getAvailableGSTSScenarios",
    value: function getAvailableGSTSScenarios() {
      // Had to install Chrome extension "Allow-Control-Allow-Origin: *"
      return axios.get(this._serverURL + "/GSTS", {
        responseType: "text",
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        return response.data.trim().split("\n").sort();
      }).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "recieveGSTSScenarioJSON",
    value: function recieveGSTSScenarioJSON(scenarioId) {
      return axios.get(this._serverURL + "/GSTS?scenarioid=" + scenarioId, {
        responseType: "json",
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "requestFwdLogsFromServer",
    value: function requestFwdLogsFromServer(logs) {
      var res = null;
      var logId = encodeURI(logs.join(","));
      res = axios.get(this._serverURL + "/GSTS?logIds=" + logId + "&encoding=json", {
        responseType: "json",
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
      return res;
    }
  }, {
    key: "requestHDF5GridFromServer",
    value: function requestHDF5GridFromServer(HDF5Path, HDF5Pointer) {
      var res = null;
      var GridId = encodeURI(HDF5Path + "," + HDF5Pointer);
      res = axios.get(this._serverURL + "/GSTS?HDF5path=" + GridId, {
        // should be post here
        responseType: "blob",
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }) //.then(function (response) {
      //    return response.data;
      //})
      .catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
      return res;
    }
  }, {
    key: "getContinuumByTag",
    value: function getContinuumByTag(tag) {
      // todo improve the efficiency, each call /continuum[s] takes around 500 ms.
      var res = null;
      res = axios.get(this._serverURL + "/continuum", {
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        var parser = new DOMParser();
        var continuaXML = parser.parseFromString(response.data, "text/xml");
        var model = new Model(continuaXML);
        var continua = model.getcontinuum();
        var c = null;

        for (var i = 0; i < continua.length; i++) {
          if (continua[i].getTag().toUpperCase() === tag.toUpperCase()) {
            c = continua[i];
            break;
          }
        }

        return c;
      }).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
      return res;
    }
  }, {
    key: "getPropertiesInContinuum",
    value: function getPropertiesInContinuum(cTag) {
      var c = this.getContinuumByTag(cTag);
      return c.getproperty();
    }
  }, {
    key: "downloadContinuumProperty",
    value: function downloadContinuumProperty(continuum, property) {
      return axios.get(this._serverURL + "/api/continuum/getData?tag=" + continuum.getTag() + "&property=" + property, {
        responseType: "json",
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        continuum.addData(property, response.data.data);
        return response.data;
      }).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "downloadContinuumPropertyVtk",
    value: function downloadContinuumPropertyVtk(continuum, property, encoding) {
      var responseType = "json";

      if (encoding == "png") {
        responseType = "blob";
      } else if (encoding == "vtk") {
        responseType = "text";
      }

      ;
      var url = this._serverURL + "/continuum?tag=" + continuum.getTag() + "&property=" + property + "&encoding=" + encoding; // console.log(url);

      return axios.get(url, {
        responseType: responseType,
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "downloadContinuumPropertyBinary",
    value: function downloadContinuumPropertyBinary(continuum, property) {
      var url = this._serverURL + "/continuum?tag=" + continuum.getTag() + "&property=" + property + "&encoding=binary"; //console.log(url);

      return axios.get(url, {
        responseType: "blob",
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(response) {
          var P;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  // console.log(response.data)
                  P = new Promise(function (resolve, reject) {
                    var reader = new FileReader();

                    reader.onload = function (e) {
                      var buffer = reader.result;
                      CesHttpClient.processBinaryData(continuum, property, buffer); //resolve(data)
                    };

                    reader.readAsArrayBuffer(response.data);
                    resolve(response.data);
                  });
                  _context5.next = 3;
                  return P;

                case 3:
                  return _context5.abrupt("return", response.data);

                case 4:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "downloadContinuumPropertyBinaryZip",
    value: function downloadContinuumPropertyBinaryZip(continuum, property) {
      var url = this._serverURL + "/continuum?tag=" + continuum.getTag() + "&property=" + property + "&encoding=zip"; //console.log(url);

      return axios.get(url, {
        responseType: "blob",
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        // console.log('Received zip content')
        return response.data;
      }).then(function (content) {
        // console.log('Unziping zip content')
        var new_zip = new JSZip();
        return new_zip.loadAsync(content);
      }).then(function (zip) {
        // console.log('Loading content')
        return zip.file("content").async("arraybuffer");
      }).then(function (buf) {
        // console.log('Reading content.');
        CesHttpClient.processBinaryData(continuum, property, buf);
        return "Success!";
      }).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "downloadContinuumMap2d",
    value: function downloadContinuumMap2d(continuum) {
      return axios.get(this._serverURL + "/api/continuum/getData?tag=" + continuum.getTag() + "&property=aux&aux=map2d", {
        responseType: "json",
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        var cellmap2d = response.data.data;
        continuum.setMap2d(cellmap2d[0]);
        return response.data;
      }).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "convertCurtainToMD",
    value: function convertCurtainToMD(continuum) {
      return axios.get(this._serverURL + "/api/continuum/curtainToMD?tag=" + continuum.getTag() + "&log=TrainingInterfaceFwdTrajectory", {
        responseType: "json",
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        continuum.setMD(response.data);
        return response.data;
      }).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "initSitecomSession",
    value: function initSitecomSession(scenarioId, sessionId, username, password) {
      var postData = {
        username: username,
        password: password
      };
      var axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          // "Access-Control-Allow-Origin": "*",
          'Authorization': "Bearer ".concat(this.authToken)
        }
      };
      console.log('initSiteComSession' + 'username=' + username + ', password=' + password + 'in json=' + postData);
      axios.post(this._serverURL + "/api/sitecom/init?scenarioId=" + scenarioId + "&sessionId=" + sessionId, postData, axiosConfig).then(function (response) {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "sendWitsmlFilesToSiteCom",
    value: function sendWitsmlFilesToSiteCom(scenarioId, sessionId, witsmlLogs, witsmlTrajectories, startMD, endMD) {
      var files = encodeURI(witsmlLogs.concat(witsmlTrajectories).join(","));
      axios.post(this._serverURL + "/api/witsml/update?scenarioId=" + scenarioId + "&sessionId=" + sessionId + "&witsmlFiles=" + files + "&MDstart=" + startMD + "&MDend=" + endMD, {}, {
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "sendMatlabContinuaToSiteCom",
    value: function sendMatlabContinuaToSiteCom(logContinuumTag, trajContinuumTag, scenarioId, sessionId, decisionId, startMD, endMD) {
      var logId = encodeURI(logs.join(","));
      console.trace("sendMatlabContinuaToSiteCom"); // return;

      axios.post(this._serverURL + "/api/witsml/update?logTag=" + logContinuumTag + "&trajectoryTag=" + trajContinuumTag + "&scenarioId=" + scenarioId + "&sessionId=" + sessionId + "&MDstart=" + startMD + "&MDend=" + endMD, {}, {
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "getColormapList",
    value: function getColormapList() {
      var _this4 = this;

      return axios.get(this._serverURL + "/api/setting/colormaps", {
        responseType: "json",
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        // console.log(JSON.stringify(response.data));
        _this4.cesDefaultColormaps = response.data;
        return response.data;
      }).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getColormapByTag",
    value: function getColormapByTag(tag) {
      return axios.get(this._serverURL + "/api/setting/colormap/get?tag=" + tag, {
        responseType: "json",
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        // console.log(JSON.stringify(response.data));
        var plotlyColorscale = CesHttpClient.convertCesColormapToPlotlyColorscale(response.data);
        return plotlyColorscale;
      }).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "executeProcess",
    value: function executeProcess(tag) {
      return axios.get(this._serverURL + "/api/process/execute?tag=" + tag, {
        responseType: "json",
        headers: {
          'Authorization': "Bearer ".concat(this.authToken)
        }
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
    }
  }], [{
    key: "processBinaryData",
    value: function processBinaryData(continuum, property, buffer) {
      // console.log("start processBinaryData for property: " + property + "; continuum Type = " + continuum.getType());
      var view = new DataView(buffer);
      var nbX, nbY;

      if (property == "X") {
        nbX = view.getInt32(0, false);
        nbY = 1;
      } else if (property == "Z") {
        nbX = 1;
        nbY = view.getInt32(0, false);
      } else {
        if (continuum.getType() == "GRID" || continuum.getType() == "IMAGELOG") {
          nbX = view.getInt32(0, false);
          nbY = view.getInt32(4, false);
        } else if (continuum.getType() == "LINE") {
          nbX = view.getInt32(0, false);
          nbY = 1;
        }
      } //console.log("nbX=" + nbX + ", nbY=" + nbY);


      var data = [];

      if (nbY == 1) {
        data = new Float64Array(nbX);

        for (var x = 0, off = 4; x < nbX; x++, off += 8) {
          data[x] = view.getFloat64(off, false);
        }
      } else if (nbX == 1) {
        data = new Float64Array(nbY);

        for (var y = 0, _off = 4; y < nbY; y++, _off += 8) {
          data[y] = view.getFloat64(_off, false);
        }
      } else {
        var dataFlip = [];

        for (var _x2 = 0, _off2 = 8; _x2 < nbX; _x2++) {
          var row = new Float64Array(nbY);

          for (var _y = 0; _y < nbY; _y++, _off2 += 8) {
            row[_y] = view.getFloat64(_off2, false);
          }

          dataFlip.push(row);
        }

        for (var _y2 = 0; _y2 < nbY; _y2++) {
          var _row = new Float64Array(nbX);

          for (var _x3 = 0; _x3 < nbX; _x3++) {
            _row[_x3] = dataFlip[_x3][_y2];
          }

          data.push(_row);
        }
      } // console.log("finish processBinaryData for property: " + property)


      continuum.addData(property, data);
    }
  }, {
    key: "convertCesColormapToPlotlyColorscale",
    value: function convertCesColormapToPlotlyColorscale(cesColormap) {
      // convert cesapi colormap to Plotly colorscale
      var cs = [];

      for (var i = 0; i < cesColormap.colormap.length; i++) {
        var par = cesColormap.range[0] + i * (cesColormap.range[1] - cesColormap.range[0]) / (cesColormap.colormap.length - 1);
        cs.push([par.toString(), "rgb(" + Math.round(255 * cesColormap.colormap[i][0]).toString() + ", " + Math.round(255 * cesColormap.colormap[i][1]).toString() + ", " + Math.round(255 * cesColormap.colormap[i][2]).toString() + ")"]);
      } //console.log(JSON.stringify(cs, null, 2));
      // this.cacheCesColormap(selectedCs, cs);


      return cs;
    }
  }]);

  return CesHttpClient;
}();